import { useEffect, useCallback, useRef } from 'react';

/**
 * Хук для отслеживания несохранённых изменений.
 *
 * - Добавляет обработчик beforeunload, когда isDirty === true
 * - Возвращает функцию confirmExit(), которую можно вызвать
 *   перед переключением вкладки / уходом со страницы.
 *   Возвращает true, если переход разрешён (нет изменений или пользователь подтвердил).
 *
 * @param {boolean} isDirty — есть ли несохранённые изменения
 * @returns {{ confirmExit: () => boolean }}
 */
export default function useUnsavedChanges(isDirty) {
    const dirtyRef = useRef(isDirty);
    dirtyRef.current = isDirty;

    useEffect(() => {
        const handler = (e) => {
            if (dirtyRef.current) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handler);
        return () => window.removeEventListener('beforeunload', handler);
    }, []);

    const confirmExit = useCallback(() => {
        if (dirtyRef.current) {
            return window.confirm('У вас есть несохранённые изменения. Покинуть страницу?');
        }
        return true;
    }, []);

    return { confirmExit };
}
